import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { ELineActions, GetLine, GetLineSuccess, GetLineFailure } from '../actions/line.actions';
import { LinesService } from '../../services/lines.service';
import { LineInterface } from '../../models/line.interface';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../../shared/abstract.effects';
import { GetConsumption } from '../actions/consumption.actions';

@Injectable()
export class LineEffects extends AbstractEffects {

    phoneNumber: string = null;

    constructor(
        private actions: Actions,
        private linesService: LinesService,
        public override store: Store<any>
    ) {
        super(store);
    }

    getLine = createEffect(() => this.actions.pipe(
        ofType<GetLine>(ELineActions.GetLine),
        tap(params => { this.phoneNumber = params.phoneNumber; }),
        switchMap(() => this.linesService.getPhoneNumberDetails(this.phoneNumber)),
        switchMap((response: LineInterface) => of(new GetLineSuccess(response))),
        tap(action => {
            if (window.location.href.includes('suiviconso')) {
                this.store.dispatch(new GetConsumption(action.payload.phoneNumber));
            }
        }),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetLine(this.phoneNumber));
            } else {
                this.DisplayMessage('error_with_retry', 400, new GetLineFailure());
            }
            return throwError(error);
        })
    ));
}
